"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _tag = require("../tag");
// TODO Remove in lodestar-core v2.
// This exists for back-compat in case someone

/**
 * @deprecated please use Tag instead.
 */
const Badge = _tag.Tag;

/**
 * @deprecated please use Tag instead.
 */

/**
 * @deprecated please use Tag instead.
 */
exports.Badge = Badge;
//# sourceMappingURL=index.js.map